'use client'

// "continue where you were": the one quiet line on the docs index that opens the
// docs page last read in this browser, at the place it was left (lib/os/places
// docs). Shown only after mount, only when that page still exists and is not
// the one already open; a plain link to a page still opens it at its top.

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { peekResumable } from '../../lib/os/resume'
import { PLACES } from '../../lib/os/places'
import { DOC_PAGES, docHref } from '../../lib/docs/content'

/** what DocsOsShell keeps as the docs are read */
export interface DocsPlace {
  path: string
  top: number
  title?: string
}

/** the event the continue link sends DocsOsShell, so the stage opens the page where it was left */
export const DOCS_CONTINUE_EVENT = 'innernet:docs-continue'

export default function DocsContinue() {
  const pathname = usePathname()
  const [place, setPlace] = useState<DocsPlace | null>(null)
  useEffect(() => {
    const kept = peekResumable<DocsPlace>(PLACES.docs())
    const page = kept && typeof kept.path === 'string' ? DOC_PAGES.find((p) => p.slug && docHref(p) === kept.path) : undefined
    // read from the browser after mount: the server's render has no place to show
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPlace(page && kept && kept.path !== pathname ? { path: kept.path, top: Math.max(0, Number(kept.top) || 0), title: page.title } : null)
  }, [pathname])
  if (!place) return null
  return (
    <p className="doc-continue">
      continue where you were:{' '}
      <Link
        className="quiet-link"
        href={place.path}
        onClick={() => window.dispatchEvent(new CustomEvent(DOCS_CONTINUE_EVENT, { detail: { path: place.path, top: place.top } }))}
      >
        {place.title}
      </Link>
    </p>
  )
}
